import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

const onboardingAnalytics = new AnalyticsService("Onboarding");

export default onboardingAnalytics;
